import axios from 'axios'
import url from '@/url.js'
import Storage from '@/helpers/storage.js'

export const state = {
    token:Storage.get('token') || '',
    dashboard:Storage.get('dashboard') || {},
    currentUser:Storage.get('currentUser') || {}
}

export const actions = {

    adminLogin({commit},data){
        return new Promise((resolve, reject)=>{ 
            axios.post(`${url()}/admin/login`,data)
            .then(response => { 
                if(response) {
                    const token = response.data.token
                    axios.defaults.headers.common['Authorization'] = token
                    commit('set_token',token)
                }
                resolve(response)
            }).catch(err => {   
               
                reject(err)
            })

        
        })
    },
    changePassword({commit},password){
        return new Promise((resolve,reject) => {
            axios.patch(`${url()}/admin/change_password`,password)
                .then(response => {
                    resolve(response)
                }).then(err => {
                    reject(err)
                })
        })
    }
    ,
    logout({commit}) {
        return new Promise((resolve,reject)=>{
            commit('logout')
            Storage.clear()
            delete axios.defaults.headers.common['Authorization']
            resolve()
        })
    },
    setDashboard({commit}, dasboard) {
        commit('set_dashboard', dasboard)
    },
    setCurrentUser({commit},user) {
        commit('set_currentUser',user)
    }
}

export const mutations = {
    logout(state) {
        state.token = ''
        state.dasboard = {}
        state.currentUser = {}
     },
    set_token(state,token) {
        state.token = token
        Storage.set('token',token)
    },
    set_currentUser(state,user) {
        state.currentUser = user
        Storage.set('currentUser', user)
    },
    set_dashboard(state,dashboard) {
        state.dashboard = dashboard
        Storage.set('dashboard',dashboard)
    }
}

export const getters = {
    // authStatus : state => state.status
    dashboard: state => state.dashboard
}
